export const docsMock = {
  title: 'Radio',
  subTitle:
    'Radio Buttons are graphical interface elements that allow user to choose only one of a predefined set of mutually exclusive options.',
  labels: ['chart', 'graph', 'ui-components', 'react'],
  installMethods: [
    { title: 'install package', content: '@google.material-ui/radio' },
    {
      title: 'Import from CDN',
      content: 'https://esm.bit.dev/@google/material-ui/radio/',
    },
  ],
};
